
export const SET_CREDENTIALS_RECORD = 'SET_CREDENTIALS_RECORD'
export const RESET_CREDENTIALS_RECORD = 'RESET_CREDENTIALS_RECORD'
export const SET_ROLES_RECORD = 'SET_ROLES_RECORD'
export const CHANGE_LOADING = 'CHANGE_LOADING'
export const SET_ERROR = 'SET_ERROR'
export const SET_HAS_ERROR = 'SET_HAS_ERROR'



// WEBPACK FOOTER //
// ./src/store/modules/credential/mutations-types.js